import React, { ReactNode, useState } from 'react';
import Button from '../../Button';
import { BUTTON_TYPES } from 'ui-library/components/Button/constants';

interface IActionButton {
    closeModal?: (param?: any) => void,
    actionFn?: (fn?: (param?: any) => void) => void,
    buttonProps?: object,
    type?: typeof BUTTON_TYPES[number],
    loading?: boolean,
    children?: ReactNode,
};

const ActionButton = (props: IActionButton) => {
    const {
        buttonProps = {},
        type = 'secondary',
        children,
        closeModal = () => {},
        actionFn = () => {}
    } = props;
    const [loading, setLoading] = useState(false);


    const handlePromiseOnOk = (returnValueOfOnOk) => {
        if (!returnValueOfOnOk || !returnValueOfOnOk.then) {
            return;
        }
        setLoading(true);
        returnValueOfOnOk.then(
            (...args) => {
                closeModal(...args);
            },
            (e) => {
                console.error(e);
                setLoading(false);
            },
        );
    };
    const onClick = () => {
        if (!actionFn) {
            closeModal();


            return;
        }
        let returnValueOfOnOk;

        if (actionFn.length) {
            returnValueOfOnOk = actionFn(closeModal);
        } else {
            returnValueOfOnOk = actionFn();
            if (!returnValueOfOnOk) {
                closeModal();


                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };

    return (
        <Button
            {...buttonProps}
            type={type}
            onClick={onClick}
            loading={loading}
        >
            {children}
        </Button>
    );
};

export default ActionButton;
